import { Component, Inject, NgZone, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { AlertService } from 'src/app/_helpers/alert.service';
import { RoutingService } from 'src/app/_services/routing.service';
import { StorageService } from 'src/app/_services/storage.service';

@Component({
  selector: 'app-notification-alert',
  templateUrl: './notification-alert.component.html',
  styleUrls: ['./notification-alert.component.scss']
})
export class NotificationAlertComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<NotificationAlertComponent>,
    private ngZone: NgZone,
    public routing: RoutingService,
    private alertService: AlertService,
    private _formBuilder: FormBuilder,
    public storage: StorageService,
    private activatedRoute: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  async ngOnInit() {
  }

  closeDialog() {
    this.ngZone.run(() => {
      this.dialogRef.close('no');
    });
  }

}
